"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _RadioButton = require("./RadioButton");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const RadioGroup = _ref => {
  let {
    options,
    selected,
    onSelect,
    color
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "radioGroup"
  }, options.map((option, i) => /*#__PURE__*/_react.default.createElement("div", {
    key: i
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: () => onSelect(option.key),
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/_react.default.createElement(_RadioButton.RadioButton, {
    active: option.key === selected,
    text: option.label,
    color: color
  })))));
};

exports.RadioGroup = RadioGroup;